<div class="u-flex u-alignCenter">
  <div
    tabindex="0"
    role="button"
    (click)="onClick($event)"
    (keydown.space)="onClick($event)"
    (keydown.enter)="onClick($event)"
  >
    <p class="t-data t-bold">{{ column.name || column.prop }}</p>
  </div>

  @if (stackedIcons || (column.stackedIcons && !stackedIcons)) {
    <span
      class="sort--container"
      [ngClass]="{ disabled: !dataExists }"
      [attr.data-test-id]="
        'Sort order: ' + sortOrder === 'asc'
          ? 'ascendingSortContainer'
          : 'descendingSortContainer'
      "
      [attr.aria-label]="
        'Sort order: ' + sortOrder === 'asc' ? 'ascending' : 'descending'
      "
      tabindex="0"
      (click)="onClick($event)"
      (keydown.space)="onClick($event)"
      (keydown.enter)="onClick($event)"
      role="button"
    >
      @if (column.sortable) {
        <icon
          class="sort sort--up"
          name="carat_up"
          [config]="{ type: 'pointer' }"
          [ngClass]="{
            'sort--active': iconSortActive('asc'),
            'sort--inactive': iconSortActive('desc'),
          }"
        >
          carat_up
        </icon>
      }
      @if (column.sortable) {
        <icon
          class="sort sort--down"
          name="carat_down"
          [config]="{ type: 'pointer' }"
          [ngClass]="{
            'sort--active': iconSortActive('desc'),
            'sort--inactive': iconSortActive('asc'),
          }"
        >
          carat_down
        </icon>
      }
    </span>
  }

  @if (!stackedIcons && !column.stackedIcons) {
    <span [ngClass]="{ disabled: !dataExists }">
      @if (column.sortable && sorts && sorts[column.prop]) {
        <icon
          [name]="sortOrder === 'asc' ? 'chevron_up' : 'chevron_down'"
          [config]="{ type: 'pointer' }"
          [attr.data-test-id]="'chevronIcon'"
          [attr.aria-label]="
            'Sort order: ' + sortOrder === 'asc' ? 'ascending' : 'descending'
          "
          tabindex="0"
          (keydown.space)="onClick($event)"
          (keydown.enter)="onClick($event)"
          role="button"
        >
          {{ sortOrder === 'asc' ? 'chevron_up' : 'chevron_down' }}
        </icon>
      }
    </span>
  }

  @if (column?.columnHeaderIcon; as icon) {
    <span class="Header__ColumnIcon" [ngClass]="{ disabled: !dataExists }">
      <icon
        tabindex="0"
        role="button"
        [attr.aria-label]="icon"
        [attr.data-test-id]="column.columnHeaderIconLabel + 'Icon'"
        [label]="column.columnHeaderIconLabel"
        [config]="{ type: 'link' }"
        [name]="icon"
        (click)="handleHeaderIconClick($event)"
        (keydown.space)="handleHeaderIconClick($event)"
        (keydown.enter)="handleHeaderIconClick($event)"
      >
      </icon>
    </span>
  }

  <ng-content></ng-content>
</div>
